// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../css/" + ({"114":"rating-plugins","1727":"archive-plugins","3176":"tablesorter-plugins","8158":"tab-plugins","8414":"svdialog","8454":"imagealbum-plugins","8991":"slideshow-plugins","9660":"comments2-plugins"}[chunkId] || chunkId) + ".css";
};